"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCopy = createCopy;
exports.getLayerOnStage = getLayerOnStage;
exports.saveAsImage = saveAsImage;
var _konva = _interopRequireDefault(require("konva"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function saveAsImage(_ref) {
  var stage = _ref.stage,
    _callback = _ref.callback;
  stage.toImage({
    callback: function callback(image) {
      if (typeof _callback === "function") {
        _callback(image);
      }
    },
    mimeType: "image/jpeg",
    quality: 1
  });
}
function createCopy(stage, width, height) {
  if (!stage || !stage.children) {
    console.warn("Undefined Konva stage or children");
    return null;
  }
  var newDiv = document.createElement("div");
  var newStage = new _konva.default.Stage({
    container: newDiv,
    width: width,
    height: height
  });
  stage.children.forEach(function (layer) {
    var clonedLayer = layer.clone({
      listening: false
    });
    newStage.add(clonedLayer);
  });

  // apply changes to stage
  newStage.batchDraw();
  return newStage;
}
function getLayerOnStage(stage, id) {
  var type = "Layer";
  // Use '#' to select elements by ID and ',' to combine multiple selectors
  var foundLayer = stage.find("#".concat(id, ", ").concat(type));
  return foundLayer[0] || null;
}